<script setup>
import { uniq } from 'lodash-es';
import { useBiStore } from '~/bi/store/bi.store';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  isPreview: {
    type: Boolean,
  },
});

const emit = defineEmits(['update:modelValue', 'back']);

const bi_store = useBiStore();

function onSelectionEnd(data) {
  if (props.isPreview)
    return;
  const stages = bi_store.widget_builder_config.query.stages;
  const all_columns = stages.flatMap(stage => stage.columns);
  const selected_columns = data.selected_columns.map(column => all_columns.find(col => col.alias === column.field));
  const selected_columns_set = new Set(selected_columns.map(obj => obj.alias));
  const unselected_columns = all_columns.filter(column => selected_columns_set.has(column.alias) === false);
  const unpivot_data = {
    type: 'union_all',
    rows: selected_columns.map(col => ({
      title: { field: col.alias, alias: 'Attribute' },
      columns: [{ field: col.alias, alias: 'Value' }, ...unselected_columns.map(col => ({ field: col.alias, alias: col.alias }))],
    })),
  };
  const types = uniq(selected_columns.map(col => col.field_type));
  emit('update:modelValue', { data: unpivot_data, types });
}
</script>

<template>
  <div :class="isPreview ? '' : 'mt-6'">
    <div v-if="isPreview" class="text-sm font-semibold text-gray-900">
      <div class="flex items-center cursor-pointer mb-2" @click="$emit('back')">
        <IconHawkArrowLeft class="text-gray-600 max-w-4 h-4 size-4 mr-2" />
        {{ $t('Back to configuration') }}
      </div>
      <div>{{ $t('Preview results') }}</div>
    </div>
    <div v-else>
      <div class="text-sm font-semibold">
        {{ $t('Select columns to unpivot') }}
      </div>
      <div class="text-xs font-normal font-gray-600 mt-1">
        {{ $t('The values from the selected columns will be extracted in to') }}
        <span class="font-semibold">{{ $t('Attribute') }}</span>
        {{ $t('and') }}
        <span class="font-semibold">{{ $t('Value') }}</span>
        {{ $t('columns') }}
      </div>
    </div>
    <div class="mt-2">
      <bi-unpivot-table :key="isPreview" :unpivot-data="isPreview ? modelValue?.data : null" :height="440" @selection-end="onSelectionEnd" />
    </div>
  </div>
</template>
